import React, { useState, useEffect } from "react";
import { View, StyleSheet, TouchableOpacity, Text, Platform } from "react-native";

import moment from "moment";

import { Calendar } from "../../../v3/common/calendar/index";
import Utils from "../../../../helpers/utils";
import AppTheme from "../../AppTheme";
import defaultCalendarTheme from "../../../defaultCalendarTheme";

const DATE_FORMAT = "YYYY-MM-DD";

export default function ResolutionInterval({
  isStartDate = false,
  label,
  goal,
  onDateChanged = () => {},
  controller = null,
  style = {},
}) {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedColumn, setSelectedColumn] = useState(null);

  const today = Utils.nowUserTz(controller).format(DATE_FORMAT);

  useEffect(() => {
    setSelectedColumn(isStartDate ? "from" : "to");
  }, [goal]);

  const setDate = (date) => {
    if (!selectedColumn) return;

    onDateChanged(selectedColumn, date);
    setSelectedDate(null);
    setSelectedColumn(null);
  };

  const toggleCalendar = () => {
    if (selectedColumn == "to" && !goal.from) return;

    if (selectedDate) {
      setSelectedDate(null);
    } else {
      setSelectedDate(goal[selectedColumn] || today);
    }
  };

  const formatDate = (date) => {
    if (!date) {
      return selectedColumn == "from"
        ? "select date"
        : selectedColumn == "to"
        ? !goal.from
          ? "-"
          : "select date"
        : "";
    }

    if (date === Utils.nowUserTz(controller).format(DATE_FORMAT)) {
      return "today";
    }

    return moment(date, DATE_FORMAT).format("MM.DD.YY");
  };

  return (
    <View style={{ width: "100%" }}>
      <View style={[styles.container, style]}>
        <Text style={styles.miniLabel}>{label}</Text>

        <TouchableOpacity onPress={toggleCalendar}>
          <Text
            style={[
              styles.dateInput,
              selectedColumn == "from" && !goal.from ? styles.dateSelected : {},
              selectedColumn == "to" && goal.from && !goal.to
                ? styles.dateSelected
                : {},
            ]}
          >
            {formatDate(goal[selectedColumn])}
          </Text>
        </TouchableOpacity>
      </View>

      {selectedDate ? (
        <Calendar
          theme={defaultCalendarTheme}
          markedDates={{
            [selectedDate]: {
              selected: true,
              backgroundColor: AppTheme.DEFAULT_COLOR,
              color: "#FFF",
            },
            [today]: {
              marked: true,
              dotColor: "#925BE8",
              color: "#000",
            },
          }}
          current={selectedDate}
          monthFormat={"MMMM yyyy"}
          onDayPress={(day) => setDate(day.dateString)}
          firstDay={7}
        />
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    paddingTop: 14,
    height: 40,
  },
  miniLabel: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
    flex: 1,
  },
  label: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    color: "#000000",
    textAlign: "center",
    marginVertical: 20,
  },
  dateInput: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    textAlign: "right",
  },
  dateSelected: {
    color: AppTheme.DEFAULT_COLOR,
  },
});
